import { queryOptions } from "@tanstack/react-query"
import { getCurrentUser } from "../auth"

export const userQueryOptions = queryOptions({
  queryKey: ["get-current-user"],
  queryFn: getCurrentUser,
  staleTime: Number.POSITIVE_INFINITY,
})
